module.exports = __webpack_public_path__ + "static/media/SRE007.e4f9bbdd.png";